import { pb } from './pb';

// Public fetch for Réalisations page
export async function fetchProjectsByCategory(categoryId){
  const filter = categoryId ? `category='${categoryId}' && published=true` : 'published=true';
  const items = await pb.collection('projects').getList(1, 50, {
    filter,
    sort: '-date,order,title',
  });
  return items.items;
}

export async function fetchProjectsByCategories(categoryIds){
  if(!Array.isArray(categoryIds) || !categoryIds.length){
    return fetchProjectsByCategory(null);
  }
  const safeIds = categoryIds.filter(Boolean);
  if(!safeIds.length){
    return fetchProjectsByCategory(null);
  }
  const orParts = safeIds.map(id => `category='${id}'`);
  const filter = `(${orParts.join(' || ')}) && published=true`;
  const items = await pb.collection('projects').getList(1, 50, {
    filter,
    sort: '-date,order,title',
  });
  return items.items;
}

export async function getProjectBySlug(slug){
  if(!slug) throw new Error('Slug manquant');
  const list = await pb.collection('projects').getList(1, 1, {
    filter: `slug="${slug}" && published=true`,
    sort: '-date,order,title',
  });
  if(!list.items.length){
    throw new Error('Réalisation introuvable');
  }
  return list.items[0];
}

// Admin helpers (similar to products)
export async function fetchProjectsAdmin(page = 1, perPage = 20, search = ''){
  const filter = search ? `title ~ "%${search}%"` : '';
  return pb.collection('projects').getList(page, perPage, {
    filter,
    sort: 'category,order,-date,title',
    expand: 'category',
  });
}

export async function createProject(data){
  return pb.collection('projects').create(data);
}

export async function updateProject(id, data){
  return pb.collection('projects').update(id, data);
}

export async function deleteProject(id){
  return pb.collection('projects').delete(id);
}